import { niiJustificationsConfigSchema } from 'features/libra/stepComponents/niiJustifications/niiJustificationsApi'
import type { LibraWorkflowStep } from 'features/libra/workflow/workflowStepsApi'
import { z } from 'zod'

export const NiiReviewConfigSchema = z.object({
  stepSequence: z.array(z.string()),
  /** Omit to hide the decision log. Not backed by a step — see `niiJustifications`. */
  justifications: niiJustificationsConfigSchema.optional(),
})

export type NiiReviewConfig = z.infer<typeof NiiReviewConfigSchema>

/**
 * The step ids a review step renders inline, or `[]` for any other step.
 * Kept out of `NiiReview.tsx` so callers don't pull in the lazily loaded
 * step component.
 */
export function getReviewedStepIds(
  step: Pick<LibraWorkflowStep, 'component' | 'config'> | undefined
): string[] {
  if (step?.component !== 'NiiReview') return []
  return NiiReviewConfigSchema.safeParse(step.config).data?.stepSequence ?? []
}
